import { node } from '@/plugins/axios'

export default {
  async sortAndFetch({ commit, dispatch }, sortBy) {
    commit('setSortBy', { ...sortBy })
    try {
      await dispatch('clearAndFetch')
    } catch (err) {
      throw err
    }
  },
  async clearAndFetch({ commit, dispatch }, parameters) {
    commit('setPage', { page: 1 })
    commit('setListings', { listings: null })
    commit('setTotal', { total: null })
    commit('setOnSale', null)
    commit('setAveragePrice', null)
    try {
      await dispatch('fetch', parameters)
    } catch (err) {
      throw err
    }
  },
  async fetch({ commit, state, getters }, parameters = {}) {
    commit('toggleLoading')
    const { request } = getters
    const { page } = parameters

    try {
      const { data } = await node.post('/listings/similar', {
        ...request,
        page: page || state.config.page,
        limit: state.config.limit
      })

      const { listings, aggs, total, averagePrice } = data

      commit('setListings', { listings })
      commit('filterBy/setAggs', { aggs })
      commit('setAveragePrice', averagePrice ?? null)

      if (total) commit('setTotal', { total })
      commit('setPage', { page: page || state.config.page })

      const counts = aggs.sold && aggs.sold.buckets.length > 0
      if (counts) {
        const forSale = aggs.sold.buckets.filter(b => b.key === 0)
        const onSale = forSale && forSale.length > 0 ? forSale[0].doc_count : 0
        commit('setOnSale', onSale)
      }

      return listings
    } catch (err) {
      commit('setListings', { listings: [] })
      if (err?.response?.status !== 401) throw err
    } finally {
      commit('toggleLoading')
    }
  }
}
